import dayjs from 'dayjs';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getProfileActionLogApi } from '@/entities/profile';
import { ApiResponse, GrassProps, GrassTileProps } from '@/shared/types';
import { clientAxios } from '@/shared/api';
import { LogLevel, logger } from '@/shared/utils';

const EMPTY_GRASS_DATA: GrassTileProps = {
  date: '',
  score: 0,
  colorLevel: 0,
};

export const getProfileActionLog = async () => {
  const startDate = dayjs().startOf('year');
  const endDate = dayjs().endOf('year');
  const daysDiff = endDate.diff(startDate, 'day') + 1;

  try {
    const { data: givenData } = await getProfileActionLogApi({
      isCurrent: false,
    });

    const grassCount = Object.keys(givenData).length;

    const grassList: GrassTileProps[] = Array.from(
      { length: daysDiff },
      (_, i) => {
        const date = startDate.add(i, 'day').format('YYYY-MM-DD');
        return givenData[date]
          ? {
              date,
              score: givenData[date].total_score,
              colorLevel: givenData[date].color_level,
            }
          : { ...EMPTY_GRASS_DATA, date };
      }
    );

    return { grassList, grassCount };
  } catch (error) {
    logger(LogLevel.ERROR, error, {
      message: 'Error fetching profile action log',
    });

    return { grassList: [], grassCount: 0 };
  }
};

export const useTodayGrassQuery = (today: string) => {
  return useSuspenseQuery({
    queryKey: ['getProfileActionLogApi', true],
    queryFn: async () => {
      const { data } = await clientAxios.get<ApiResponse<GrassProps>>(
        '/getProfileActionLogApi/',
        {
          params: {
            isCurrent: true,
          },
        }
      );

      const grassData = data.data[today];

      return {
        score: grassData.total_score,
        colorLevel: grassData.color_level,
      };
    },
  });
};
